var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrategyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#2D3021"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3023 16H41.2043H43.1962V17.9918L43.1962 41.8939H41.2043L41.2043 19.864L17.4084 43.6599L16 42.2515L40.2596 17.9918H17.3023V16Z",
    fill: "#DBFD6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyArrow);
export default __webpack_public_path__ + "static/media/strategy-arrow.7bc9697e5e250fd1404aae50bd1ee747.svg";
export { ForwardRef as ReactComponent };